import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8cbe44a8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  style: {
    "margin": "16px"
  }
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 登录 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_form = _resolveComponent("van-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, null, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.phone,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.phone = $event),
        name: "手机号",
        label: "手机号",
        placeholder: "手机号",
        autocomplete: "off",
        rules: [{
          required: true,
          message: '手机号'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.password = $event),
        type: "password",
        name: "密码",
        label: "密码",
        autocomplete: "off",
        placeholder: "密码",
        rules: [{
          required: true,
          message: '请填写密码'
        }]
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      "native-type": "submit",
      onClick: $options.login
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  })]);
}